export enum Relationship {
  Spouse = 2,
  Child = 3,
  Group = 6,
}

export enum RelationshipToPolicyOwner {
  Father = 1,
  Mother = 2,
  Brother = 3,
  Sister = 4,
  Son = 5,
  Daughter = 6,
  Husband = 7,
  Wife = 8,
  Nephew = 9,
  Niece = 10,
  Grandparent = 11,
  LegalGuardian = 12,
  Friend = 13,
  Relative = 14,
  NotApplicable = 15,
}
